require('../vendor/slick.min');

if($("#case-study-single").length) {

    let slider = $('.case-study-slider'),
        slideItems = $('.slider-item'),
        thumbnailItems = $('.thumbnail-item'),
        thumbnailSlider = $('.case-study-slider-thumbnails'),
        offset = ($('.wrapper').width() - $('.row').width()) / 2,
        prevButton = $('.case-study-slider-prev'),
        nextButton = $('.case-study-slider-next');

    function sliderSizing() {
        if($(window).width() > 991) {
            $('.case-study-contents-left-inner').css('margin-left', 0 - offset);
        } else {
            $('.case-study-contents-left-inner').css('margin-left', '');
        }
    }
    $('#case-study-single').imagesLoaded(function () {
        sliderSizing();
    });

    $(window).on('resize', function () {
        sliderSizing();
    });

    slider.slick({
        adaptiveHeight: true,
    });

    // if(slideItems.length > 5) {
    //     slider.slick({
    //         adaptiveHeight: true,
    //         asNavFor: thumbnailSlider
    //     });
    // } else {
    //     slider.slick({
    //         adaptiveHeight: true,
    //     });
    // }

    prevButton.on('click', function () {
        slider.slick('slickPrev');
        correctThumbnailsScroll();
    });

    nextButton.on('click', function () {
        slider.slick('slickNext');
        correctThumbnailsScroll();
    });

    thumbnailItems.on('click', function () {
        let slideIndex = $(this).data('slide-index');
        slider.slick('slickGoTo', slideIndex);
    });

    function correctThumbnailsScroll() {
        // console.log(slider.slickCurrentSlide);
    }

    slider.on('afterChange', function (slick, currentSlide) {
        let activeThumbnail = $('.thumbnail-item[data-slide-index=' + currentSlide.currentSlide + ']');
        console.log(currentSlide.currentSlide);
        thumbnailItems.not(activeThumbnail).removeClass('active-thumbnail');
        activeThumbnail.addClass('active-thumbnail');
    });

    // if(slideItems.length > 5) {
    //     thumbnailSlider.slick({
    //         asNavFor: slider,
    //         slidesToShow: 5,
    //     });
    // } else {
    //     thumbnailSlider.slick({
    //         slidesToShow: 5,
    //     });
    // }

}
